import { render, staticRenderFns } from "./formClassCollect.vue?vue&type=template&id=152a015e&scoped=true&"
import script from "./formClassCollect.vue?vue&type=script&lang=js&"
export * from "./formClassCollect.vue?vue&type=script&lang=js&"
import style0 from "./formClassCollect.vue?vue&type=style&index=0&id=152a015e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a015e",
  null
  
)

export default component.exports